import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "../src/assets/stylesheets/global.css";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { MobXProviderContext } from "mobx-react";
import onboardingStore from "mobXstore/onboardingStore";
import * as Sentry from "@sentry/react";

console.log(process.env.REACT_APP_NODE_ENV, "environment");

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN_KEY,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
    }),
    Sentry.replayIntegration(),
  ],
  environment: process.env.REACT_APP_NODE_ENV,
  tracesSampleRate: 1.0,
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <MobXProviderContext.Provider value={{ onboardingStore }}>
      <BrowserRouter basename="/get-started">
        <App />
      </BrowserRouter>
    </MobXProviderContext.Provider>
  </React.StrictMode>
);
